import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "toolbox-overlay"
};
const _hoisted_2 = {
  class: "toolbox-overlay__bar"
};
const _hoisted_3 = {
  class: "toolbox-overlay__body"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("button", {
    class: "toolbox-overlay__back",
    type: "button",
    onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('close'))
  }, [_cache[2] || (_cache[2] = _createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "18",
    height: "18",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2.2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, [_createElementVNode("line", {
    x1: "19",
    y1: "12",
    x2: "5",
    y2: "12"
  }), _createElementVNode("polyline", {
    points: "12 19 5 12 12 5"
  })], -1)), _createElementVNode("span", null, _toDisplayString(_ctx.$t("assessments.My_assessments")), 1)]), _createElementVNode("button", {
    class: "toolbox-overlay__close",
    type: "button",
    "aria-label": "Close",
    onClick: _cache[1] || (_cache[1] = $event => _ctx.$emit('close'))
  }, _cache[3] || (_cache[3] = [_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2.2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, [_createElementVNode("line", {
    x1: "18",
    y1: "6",
    x2: "6",
    y2: "18"
  }), _createElementVNode("line", {
    x1: "6",
    y1: "6",
    x2: "18",
    y2: "18"
  })], -1)]))]), _createElementVNode("div", _hoisted_3, [_renderSlot(_ctx.$slots, "default", {}, undefined, true)])]);
}